<div class="container">
  <div class="offset-1 col-10">

    <div class=" content">
      <div class=" row">
        <div class=" col-12">
          <div class=" card card-chart">
            <div class=" card-header">
              <div class=" row">
                <div class=" col-sm-6 text-left">
                  <h5 class=" card-category">Analytics</h5>
                  <h2 class=" card-title"><i class="fab fa-sellsy fa-lg"></i>&nbsp;&nbsp;&nbsp; Performance & Risk</h2>
                </div>
                <div class=" col-sm-6">
                  <div class=" btn-group float-right">
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedAllTab=='overview'}"
                           (click)="selectedAllTab='overview';selectedOverviewTab='all'">Overview</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedAllTab=='absolute'}"
                           (click)="selectedAllTab='absolute';selectedAbsoluteTab='Returns'">Absolute</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedAllTab=='relative'}"
                           (click)="selectedAllTab='relative';selectedRelativeTab='Excess Returns'">Relative</label>
                    <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedAllTab=='components'}"
                           (click)="selectedAllTab='components';selectedComponentsTab='analytics'"
                           *ngIf="currentCA && currentCA.components.length>0">Components</label>
                  </div>
                </div>
              </div>
            </div>
            <div class=" card-body">
              <div *ngIf="selectedAllTab=='overview'">
                <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                <!--Overview Section-->
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onOverviewTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab *ngIf="originalPRA || investablePRA || protectedPRA" label="All since inception"></mat-tab>
                  <mat-tab *ngIf="originalPRA" label="Original"></mat-tab>
                  <mat-tab *ngIf="investablePRA" label="Investable"></mat-tab>
                  <mat-tab *ngIf="protectedPRA" label="Protected"></mat-tab>
                </mat-tab-group>

                <br>
                <table id="tableToExport" *ngIf="selectedOverviewTab=='all' && (originalPRA || investablePRA || protectedPRA)" mdbTable small="true">
                  <thead>
                    <tr>
                      <th scope="col" width="40%"></th>
                      <th *ngIf="originalPRA" scope="col">Original</th>
                      <th *ngIf="benchmarkPRA" scope="col" >Benchmark</th>
                      <th *ngIf="investablePRA" scope="col">Investable</th>
                      <th *ngIf="protectedPRA" scope="col">Protected</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Returns</th>
                      <td *ngIf="originalPRA">{{ originalPRA.returns.inception | percent:'.1' }}</td>
                      <td *ngIf="benchmarkPRA">{{ benchmarkPRA.returns.inception | percent:'.1' }}</td>
                      <td *ngIf="investablePRA">{{ investablePRA.returns.inception | percent:'.1' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.returns.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Volatility</th>
                      <td *ngIf="originalPRA">{{ originalPRA.volatility.inception | percent:'.1' }}</td>
                      <td *ngIf="benchmarkPRA">{{ benchmarkPRA.volatility.inception | percent:'.1' }}</td>
                      <td *ngIf="investablePRA">{{ investablePRA.volatility.inception | percent:'.1' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.volatility.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Sharpe ratio</th>
                      <td *ngIf="originalPRA">{{ originalPRA.sharpe_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="benchmarkPRA">{{ benchmarkPRA.sharpe_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="investablePRA">{{ investablePRA.sharpe_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.sharpe_ratio.inception | number:'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Maximum Drawdown</th>
                      <td *ngIf="originalPRA">{{ originalPRA.maximum_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="benchmarkPRA">{{ benchmarkPRA.maximum_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="investablePRA">{{ investablePRA.maximum_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.maximum_drawdown.inception | percent:'.1' }}</td>
                    </tr>
                  </tbody>
                  <thead>
                  <tr>
                    <th scope="col" width="40%"></th>
                    <th *ngIf="originalPRA" scope="col"></th>
                    <th *ngIf="benchmarkPRA" scope="col" ></th>
                    <th *ngIf="investablePRA" scope="col"></th>
                    <th *ngIf="protectedPRA" scope="col"></th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Excess Returns</th>
                      <td *ngIf="originalPRA">{{ originalPRA.excess_returns.inception | percent:'.1' }}</td>
                      <td *ngIf="benchmarkPRA">—</td>
                      <td *ngIf="investablePRA">{{ investablePRA.excess_returns.inception | percent:'.1' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.excess_returns.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Tracking Error</th>
                      <td *ngIf="originalPRA">{{ originalPRA.tracking_error.inception | percent:'.1' }}</td>
                      <td *ngIf="benchmarkPRA">—</td>
                      <td *ngIf="investablePRA">{{ investablePRA.tracking_error.inception | percent:'.1' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.tracking_error.inception | percent:'.1' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Information ratio</th>
                      <td *ngIf="originalPRA">{{ originalPRA.information_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="benchmarkPRA">—</td>
                      <td *ngIf="investablePRA">{{ investablePRA.information_ratio.inception | number:'1.2-2' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.information_ratio.inception | number:'1.2-2' }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Maximum Relative Drawdown</th>
                      <td *ngIf="originalPRA">{{ originalPRA.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="benchmarkPRA">—</td>
                      <td *ngIf="investablePRA">{{ investablePRA.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                      <td *ngIf="protectedPRA">{{ protectedPRA.maximum_relative_drawdown.inception | percent:'.1' }}</td>
                    </tr>
                  </tbody>
                </table>

                <table id="tableToExport" *ngIf="selectedOverviewTab=='original' && originalPRA" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Returns</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.returns[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Volatility</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.volatility[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Sharpe ratio</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Maximum Drawdown</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" ></th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Excess Returns</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.excess_returns[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tracking Error</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.tracking_error[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Information ratio</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.information_ratio[cat] | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Maximum Relative Drawdown</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>

                <table id="tableToExport" *ngIf="selectedOverviewTab=='investable' && investablePRA" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngIf="investablePRA && investablePRA.returns">
                    <th scope="row">Returns</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.returns[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Volatility</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.volatility[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Sharpe ratio</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Maximum Drawdown</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" ></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Excess Returns</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.excess_returns[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tracking Error</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.tracking_error[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Information ratio</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.information_ratio[cat] | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Maximum Relative Drawdown</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>

                <table id="tableToExport" *ngIf="selectedOverviewTab=='protected' && protectedPRA" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Returns</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.returns[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Volatility</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.volatility[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Sharpe ratio</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Maximum Drawdown</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" ></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">Excess Returns</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.excess_returns[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tracking Error</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.tracking_error[cat] | percent:'.1' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Information ratio</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.information_ratio[cat] | number:'1.2-2' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Maximum Relative Drawdown</th>
                    <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>

                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                  </em>
                </div>
                <!--Overview Section-->
              </div>
              <div *ngIf="selectedAllTab=='absolute'">
                <!-- Absolute Tables -->
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onAbsoluteTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab *ngIf="(originalPRA && originalPRA.returns) || (investablePRA && investablePRA.returns) || (protectedPRA && protectedPRA.returns)" label="Returns"></mat-tab>
                  <mat-tab *ngIf="(originalPRA && originalPRA.volatility) || (investablePRA && investablePRA.volatility) || (protectedPRA && protectedPRA.volatility)" label="Volatility"></mat-tab>
                  <mat-tab *ngIf="(originalPRA && originalPRA.sharpe_ratio) || (investablePRA && investablePRA.sharpe_ratio) || (protectedPRA && protectedPRA.sharpe_ratio)" label="Sharpe ratio"></mat-tab>
                  <mat-tab *ngIf="(originalPRA && originalPRA.maximum_drawdown) || (investablePRA && investablePRA.maximum_drawdown) || (protectedPRA && protectedPRA.maximum_drawdown)" label="Max Drawdown"></mat-tab>
                  <mat-tab *ngIf="(originalPRA && originalPRA.cornish_fisher_5pct) || (investablePRA && investablePRA.cornish_fisher_5pct) || (protectedPRA && protectedPRA.cornish_fisher_5pct)" label="Value at Risk"></mat-tab>
                  <mat-tab *ngIf="(originalPRA && originalPRA.calmar_ratio) || (investablePRA && investablePRA.calmar_ratio) || (protectedPRA && protectedPRA.calmar_ratio)" label="Calmar ratio"></mat-tab>
                  <mat-tab *ngIf="(originalPRA && originalPRA.yearly_returns) || (investablePRA && investablePRA.yearly_returns) || (protectedPRA && protectedPRA.yearly_returns)" label="Yearly Returns"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Returns line chart -->
                <app-basic-line-chart *ngIf="selectedAbsoluteTab=='Returns' &&
                                               (originalPRA || investablePRA || protectedPRA)"
                                      [series]="[
                                          {label: 'original',   historical_values: originalPRA ? originalPRA.returns.historical_values : undefined},
                                          {label: 'investable', historical_values: investablePRA ? investablePRA.returns.historical_values : undefined},
                                          {label: 'protected',  historical_values: protectedPRA ? protectedPRA.returns.historical_values : undefined},
                                          {label: 'benchmark',  historical_values: benchmarkPRA ? benchmarkPRA.returns.historical_values : undefined}
                                        ]">
                </app-basic-line-chart>
                <!-- Returns line chart -->

                <!-- Volatility line chart -->
                <app-basic-line-chart *ngIf="selectedAbsoluteTab=='Volatility' &&
                                               (originalPRA || investablePRA || protectedPRA)"
                                      [series]="[
                                          {label: 'original',   historical_values: originalPRA ? originalPRA.volatility.historical_values : undefined},
                                          {label: 'investable', historical_values: investablePRA ? investablePRA.volatility.historical_values : undefined},
                                          {label: 'protected',  historical_values: protectedPRA ? protectedPRA.volatility.historical_values : undefined},
                                          {label: 'benchmark',  historical_values: benchmarkPRA ? benchmarkPRA.volatility.historical_values : undefined}
                                        ]" percent>
                </app-basic-line-chart>
                <!-- Volatility line chart -->

                <!-- Sharpe ratio bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Sharpe ratio' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [catNames]="['YTD','1Y','3Y','5Y','10Y','Inception']"
                                     [catFields]="['YTD','1y','3y','5y','10y','inception']"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.sharpe_ratio : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.sharpe_ratio : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.sharpe_ratio : undefined},
                                         {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.sharpe_ratio : undefined}
                                       ]">
                </app-basic-bar-chart>
                <!-- Sharpe ratio bar chart -->

                <!-- Maximum Drawdown bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Max Drawdown' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [catNames]="['YTD','1Y','3Y','5Y','10Y','Inception']"
                                     [catFields]="['YTD','1y','3y','5y','10y','inception']"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.maximum_drawdown : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.maximum_drawdown : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.maximum_drawdown : undefined},
                                         {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.maximum_drawdown : undefined}
                                       ]" opposite percent>
                </app-basic-bar-chart>
                <!-- Maximum Drawdown bar chart -->

                <!-- Value at Risk bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Value at Risk' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [catNames]="['YTD','1Y','3Y','5Y','10Y','Inception']"
                                     [catFields]="['YTD','1y','3y','5y','10y','inception']"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.cornish_fisher_5pct : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.cornish_fisher_5pct : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.cornish_fisher_5pct : undefined},
                                         {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.cornish_fisher_5pct : undefined}
                                       ]" percent>
                </app-basic-bar-chart>
                <!-- Value at Risk bar chart -->

                <!-- Calmar ratio bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Calmar ratio' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [catNames]="['YTD','1Y','3Y','5Y','10Y','Inception']"
                                     [catFields]="['YTD','1y','3y','5y','10y','inception']"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.calmar_ratio : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.calmar_ratio : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.calmar_ratio : undefined},
                                         {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.calmar_ratio : undefined}
                                       ]">
                </app-basic-bar-chart>
                <!-- Calmer ratio bar chart -->

                <!-- Yearly Returns bar chart -->
                <app-basic-bar-chart *ngIf="selectedAbsoluteTab=='Yearly Returns' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.yearly_returns : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.yearly_returns : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.yearly_returns : undefined},
                                         {label: 'benchmark',  values: benchmarkPRA ? benchmarkPRA.yearly_returns : undefined}
                                       ]" zoomType="x" percent>
                </app-basic-bar-chart>
                <!-- Yearly Returns bar chart -->
                <!-- Absolute Tables -->
              </div>
              <div *ngIf="selectedAllTab=='relative'">
                <!-- Relative Tables -->
                  <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onRelativeTabChange($event)">
                    <!--    .                                      -->
                    <!--   / \   Do not change mat-tab labels.     -->
                    <!--  / ! \  They are used in typescript code. -->
                    <!-- /_____\                                   -->
                    <mat-tab *ngIf="(originalPRA && originalPRA.excess_returns) || (investablePRA && investablePRA.excess_returns) || (protectedPRA && protectedPRA.excess_returns)" label="Excess Returns"></mat-tab>
                    <mat-tab *ngIf="(originalPRA && originalPRA.tracking_error) || (investablePRA && investablePRA.tracking_error) || (protectedPRA && protectedPRA.tracking_error)" label="Tracking Error"></mat-tab>
                    <mat-tab *ngIf="(originalPRA && originalPRA.information_ratio) || (investablePRA && investablePRA.information_ratio) || (protectedPRA && protectedPRA.information_ratio)" label="Information ratio"></mat-tab>
                    <mat-tab *ngIf="(originalPRA && originalPRA.maximum_relative_drawdown) || (investablePRA && investablePRA.maximum_relative_drawdown) || (protectedPRA && protectedPRA.maximum_relative_drawdown)" label="Max Relative Drawdown"></mat-tab>
                    <mat-tab *ngIf="(originalPRA && originalPRA.market_exposure) || (investablePRA && investablePRA.market_exposure) || (protectedPRA && protectedPRA.market_exposure)" label="Market Exposure"></mat-tab>
                  </mat-tab-group>

                  <br>
                <!-- Excess Returns line chart -->
                <app-basic-line-chart *ngIf="selectedRelativeTab=='Excess Returns' &&
                                               (originalPRA || investablePRA || protectedPRA)"
                                      [series]="[
                                          {label: 'original',   historical_values: originalPRA ? originalPRA.excess_returns.historical_values : undefined},
                                          {label: 'investable', historical_values: investablePRA ? investablePRA.excess_returns.historical_values : undefined},
                                          {label: 'protected',  historical_values: protectedPRA ? protectedPRA.excess_returns.historical_values : undefined}
                                        ]">
                </app-basic-line-chart>
                <!-- Excess Returns line chart -->

                <!-- Tracking Error line chart -->
                <app-basic-line-chart *ngIf="selectedRelativeTab=='Tracking Error' &&
                                               (originalPRA || investablePRA || protectedPRA)"
                                      [series]="[
                                          {label: 'original',   historical_values: originalPRA ? originalPRA.tracking_error.historical_values : undefined},
                                          {label: 'investable', historical_values: investablePRA ? investablePRA.tracking_error.historical_values : undefined},
                                          {label: 'protected',  historical_values: protectedPRA ? protectedPRA.tracking_error.historical_values : undefined}
                                        ]" percent>
                </app-basic-line-chart>
                <!-- Tracking Error line chart -->

                <!-- Information ratio bar chart -->
                <app-basic-bar-chart *ngIf="selectedRelativeTab=='Information ratio' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [catNames]="['YTD','1Y','3Y','5Y','10Y','Inception']"
                                     [catFields]="['YTD','1y','3y','5y','10y','inception']"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.information_ratio : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.information_ratio : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.information_ratio : undefined}
                                       ]">
                </app-basic-bar-chart>
                <!-- Information ratio bar chart -->

                <!-- Maximum Relative Drawdown bar chart -->
                <app-basic-bar-chart *ngIf="selectedRelativeTab=='Max Relative Drawdown' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [catNames]="['YTD','1Y','3Y','5Y','10Y','Inception']"
                                     [catFields]="['YTD','1y','3y','5y','10y','inception']"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.maximum_relative_drawdown : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.maximum_relative_drawdown : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.maximum_relative_drawdown : undefined}
                                       ]" opposite percent>
                </app-basic-bar-chart>
                <!-- Maximum Relative Drawdown bar chart -->

                <!-- Market Exposure bar chart -->
                <app-basic-bar-chart *ngIf="selectedRelativeTab=='Market Exposure' &&
                                              (originalPRA || investablePRA || protectedPRA)"
                                     [catNames]="['YTD','1Y','3Y','5Y','10Y','Inception']"
                                     [catFields]="['YTD','1y','3y','5y','10y','inception']"
                                     [series]="[
                                         {label: 'original',   values: originalPRA ? originalPRA.market_exposure : undefined},
                                         {label: 'investable', values: investablePRA ? investablePRA.market_exposure : undefined},
                                         {label: 'protected',  values: protectedPRA ? protectedPRA.market_exposure : undefined}
                                       ]" percent>
                </app-basic-bar-chart>
                <!-- Market Exposure bar chart -->
            </div>
              <div *ngIf="selectedAllTab=='components'">
                <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                <mat-tab-group mat-align-tabs="center" animationDuration="0ms" (selectedTabChange)="onComponentsTabChange($event)">
                  <!--    .                                      -->
                  <!--   / \   Do not change mat-tab labels.     -->
                  <!--  / ! \  They are used in typescript code. -->
                  <!-- /_____\                                   -->
                  <mat-tab label="Analytics"></mat-tab>
                  <mat-tab label="Contributions"></mat-tab>
                  <mat-tab label="Rating"></mat-tab>
                </mat-tab-group>

                <br>
                <!-- Analytics table -->
                <table id="tableToExport" *ngIf="selectedComponentsTab=='analytics'" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of ['Returns','Volatility','Sharpe ratio','Max Drawdown']" scope="col" >{{ cat }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let component of currentCA.components">
                    <th scope="row">{{ component.name }}</th>
                    <td scope="col">{{ component.returns | percent:'.1' }}</td>
                    <td scope="col">{{ component.volatility | percent:'.1' }}</td>
                    <td scope="col">{{ component.sharpe_ratio | number:'1.2-2' }}</td>
                    <td scope="col">{{ component.maximum_drawdown | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Analytics table -->

                <!-- Contribution table -->
                <table id="tableToExport" *ngIf="selectedComponentsTab=='contribution'" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of ['Alpha','Performance','Risk','Intensity']" scope="col" >{{ cat }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let component of currentCA.components">
                    <th scope="row">{{ component.name }}</th>
                    <td *ngFor="let cat of ['alpha','returns','volatility','factor_intensity']" scope="col" >{{ component.contribution[cat] | percent:'.1' }}</td>
                  </tr>
                  </tbody>
                </table>
                <!-- Contribution table -->

                <!-- Ratings table -->
                <table id="tableToExport" *ngIf="selectedComponentsTab=='rating'" mdbTable small="true">
                  <thead>
                  <tr>
                    <th scope="col" width="30%"></th>
                    <th *ngFor="let cat of [
                            'Deconcentration',
                            'Diversification'
                          ]" scope="col" >{{ cat }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let component of currentCA.components">
                    <th scope="row">{{ component.name }}</th>
                    <td *ngFor="let cat of [
                            'factor_deconcentration_quality_rating',
                            'factor_diversification_quality_rating'
                          ]" class="rating" scope="col" >
                      <span style="font-size:1.8em" [outerHTML]="component.ratings[cat] | rating"></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!-- Ratings table -->

                <div class="w-100">
                  <em class="float-right" style="font-size:0.7em">
                    {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                  </em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedAllTab=='absolute' || selectedAllTab=='relative'" class=" content">
        <br>
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-center">
                    <h2 class=" card-title"><span *ngIf="selectedAllTab=='absolute'">{{ selectedAbsoluteTab }}</span>
                      <span *ngIf="selectedAllTab=='relative'">{{ selectedRelativeTab }}</span></h2>
                  </div>
                </div>
              </div>
              <div class=" card-body">
                <a class="float-right" style="color: grey" (click)="exportTable()"><i class="fas fa-download"></i></a>
                <div *ngIf="selectedAllTab=='absolute'">
                  <!-- Returns table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Returns' && ((originalPRA && originalPRA.returns) || (investablePRA && investablePRA.returns) || (protectedPRA && protectedPRA.returns))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA && benchmarkPRA.returns">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ benchmarkPRA.returns[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Returns table -->

                  <!-- Volatility table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Volatility' && ((originalPRA && originalPRA.volatility) || (investablePRA && investablePRA.volatility) || (protectedPRA && protectedPRA.volatility))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA && benchmarkPRA.returns">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ benchmarkPRA.volatility[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Volatility table -->

                  <!-- Sharpe ratio table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Sharpe ratio' && ((originalPRA && originalPRA.sharpe_ratio) || (investablePRA && investablePRA.sharpe_ratio) || (protectedPRA && protectedPRA.sharpe_ratio))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA && benchmarkPRA.returns">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ benchmarkPRA.sharpe_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Sharpe ratio table -->

                  <!-- Max. Drawdown table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Max Drawdown' && ((originalPRA && originalPRA.maximum_drawdown) || (investablePRA && investablePRA.maximum_drawdown) || (protectedPRA && protectedPRA.maximum_drawdown))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA && benchmarkPRA.returns">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ benchmarkPRA.maximum_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Max. Drawdown table -->

                  <!-- Value at Risk table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Value at Risk' && ((originalPRA && originalPRA.cornish_fisher_5pct) || (investablePRA && investablePRA.cornish_fisher_5pct) || (protectedPRA && protectedPRA.cornish_fisher_5pct))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.cornish_fisher_5pct[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.cornish_fisher_5pct[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.cornish_fisher_5pct[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA && benchmarkPRA.returns">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ benchmarkPRA.cornish_fisher_5pct[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Value at Risk table -->

                  <!-- Calmar ratio table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Calmar ratio' && ((originalPRA && originalPRA.calmar_ratio) || (investablePRA && investablePRA.calmar_ratio) || (protectedPRA && protectedPRA.calmar_ratio))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.calmar_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.calmar_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.calmar_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA && benchmarkPRA.returns">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ benchmarkPRA.calmar_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Calmar ratio table -->

                  <!-- Yearly Returns table -->
                  <table id="tableToExport" *ngIf="selectedAbsoluteTab=='Yearly Returns' && ((originalPRA && originalPRA.yearly_returns) || (investablePRA && investablePRA.yearly_returns) || (protectedPRA && protectedPRA.yearly_returns))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let year of lastYears" scope="col" >{{ year }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.yearly_returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let year of lastYears">{{ originalPRA.yearly_returns[year] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.yearly_returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let year of lastYears">{{ investablePRA.yearly_returns[year] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.yearly_returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let year of lastYears">{{ protectedPRA.yearly_returns[year] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="benchmarkPRA && benchmarkPRA.yearly_returns">
                      <th scope="row">Benchmark</th>
                      <td *ngFor="let year of lastYears">{{ benchmarkPRA.yearly_returns[year] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Yearly Returns table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
                <div *ngIf="selectedAllTab=='relative'">
                  <!-- Excess Returns table -->
                  <table id="tableToExport" *ngIf="selectedRelativeTab=='Excess Returns' && ((originalPRA && originalPRA.excess_returns) || (investablePRA && investablePRA.excess_returns) || (protectedPRA && protectedPRA.excess_returns))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.excess_returns">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.excess_returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.excess_returns">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.excess_returns[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.excess_returns">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.excess_returns[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Excess Returns table -->

                  <!-- Tracking Error table -->
                  <table  id="tableToExport"*ngIf="selectedRelativeTab=='Tracking Error' && ((originalPRA && originalPRA.tracking_error) || (investablePRA && investablePRA.tracking_error) || (protectedPRA && protectedPRA.tracking_error))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.tracking_error">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.tracking_error[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.tracking_error">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.tracking_error[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.tracking_error">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.tracking_error[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Tracking Error table -->

                  <!-- Information ratio table -->
                  <table id="tableToExport" *ngIf="selectedRelativeTab=='Information ratio' && ((originalPRA && originalPRA.information_ratio) || (investablePRA && investablePRA.information_ratio) || (protectedPRA && protectedPRA.information_ratio))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.information_ratio">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.information_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.information_ratio">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.information_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.information_ratio">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.information_ratio[cat] | number:'1.2-2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Information ratio table -->

                  <!-- Max. Relative Drawdown table -->
                  <table id="tableToExport" *ngIf="selectedRelativeTab=='Max Relative Drawdown' && ((originalPRA && originalPRA.maximum_relative_drawdown) || (investablePRA && investablePRA.maximum_relative_drawdown) || (protectedPRA && protectedPRA.maximum_relative_drawdown))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.maximum_relative_drawdown">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.maximum_relative_drawdown">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.maximum_relative_drawdown">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.maximum_relative_drawdown[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Max. Relative Drawdown table -->

                  <!-- Market Exposure table -->
                  <table id="tableToExport" *ngIf="selectedRelativeTab=='Market Exposure' && ((originalPRA && originalPRA.market_exposure) || (investablePRA && investablePRA.market_exposure) || (protectedPRA && protectedPRA.market_exposure))" mdbTable small="true">
                    <thead>
                    <tr>
                      <th scope="col" width="30%"></th>
                      <th *ngFor="let cat of ['YTD','1Y','3Y','5Y','10Y','Inception']" scope="col" >{{ cat }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="originalPRA && originalPRA.market_exposure">
                      <th scope="row">Original</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ originalPRA.market_exposure[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="investablePRA && investablePRA.market_exposure">
                      <th scope="row">Investable</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ investablePRA.market_exposure[cat] | percent:'.1' }}</td>
                    </tr>
                    <tr *ngIf="protectedPRA && protectedPRA.market_exposure">
                      <th scope="row">Protected</th>
                      <td *ngFor="let cat of ['YTD','1y','3y','5y','10y','inception']">{{ protectedPRA.market_exposure[cat] | percent:'.1' }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- Market Exposure table -->

                  <div class="w-100">
                    <em class="float-right" style="font-size:0.7em">
                      {{ inceptionDate | date:'MMMM d, y' }} — {{ lastDate | date:'MMMM d, y' }}
                    </em>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
